import { render, staticRenderFns } from "./SimilarReplyRequestsStep.vue?vue&type=template&id=c9dc7202&"
import script from "./SimilarReplyRequestsStep.vue?vue&type=script&lang=js&"
export * from "./SimilarReplyRequestsStep.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports